import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CTASectionProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonHref?: string;
  variant?: "default" | "accent";
  eyebrow?: string;
}

export function CTASection({
  title,
  description,
  buttonText = "Kontaktirajte nas",
  buttonHref = "/kontakt",
  variant = "default",
  eyebrow,
}: CTASectionProps) {
  return (
    <section
      className={
        variant === "accent"
          ? "bg-accent text-accent-foreground"
          : "bg-ivory relative"
      }
    >
      {/* Decorative gold accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-transparent via-gold to-transparent" />
      
      <div className="container py-20 md:py-32">
        <div className="max-w-3xl mx-auto text-center">
          {eyebrow && (
            <p className={`text-sm uppercase tracking-[0.3em] font-medium mb-4 ${
              variant === "accent" ? "text-espresso/80" : "text-gold-dark"
            }`}>
              {eyebrow}
            </p>
          )}
          <h2 className={`mb-6 font-serif font-normal ${
            variant === "accent" ? "text-espresso" : "text-charcoal"
          }`}>{title}</h2>
          <p className={`text-xl md:text-2xl mb-8 text-balance font-light ${
            variant === "accent" ? "text-espresso/90" : "text-muted-foreground"
          }`}>
            {description}
          </p>
          <Button
            asChild
            size="lg"
            className={`text-lg ${
              variant === "accent" 
                ? "bg-ivory text-charcoal hover:bg-ivory/90" 
                : "bg-charcoal text-ivory hover:bg-charcoal/90"
            }`}
          >
            <Link to={buttonHref}>
              {buttonText}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
